export const KEY_STORES = {
  accessToken: "accessToken",
};
